/* eslint-disable no-undef */
import React, { useEffect, Fragment, useContext, useMemo, useCallback } from 'react';
import { Helmet } from 'react-helmet';
// import useRouter from 'utils/useRouter';
import { ErrorHandler } from 'components';
import { useLocation } from "react-router";
import { ILayoutContextValues, LayoutContext } from 'contexts/LayoutContext';
import { Box, Fade, Grow } from '@mui/material';

const NODE_ENV = process.env.NODE_ENV;

interface PagePros {
  title: string;
  description?: string;
  image?: string;
  children: any;
  layoutOptions?: ILayoutContextValues;
}

const Page = (props: PagePros) => {
  const { title, description = '', image, children, layoutOptions } = props;
  const location = useLocation();
  const layoutContext = useContext(LayoutContext);

  useEffect(() => {
    if (NODE_ENV !== 'production') {
      return;
    }
    //@ts-ignore
    if (window.gtag) {
      //@ts-ignore
      // window.gtag('config', GA_MEASUREMENT_ID, {
      //   page_path: location.pathname,
      //   page_name: title
      // });
    }
  }, [title, location]);

  useEffect(() => {
    layoutContext?.setNavbarType(layoutOptions?.navbarType ?? 'expanded');
  }, [layoutOptions])

  return (
    <Fragment>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {image && <meta name="image" content={image} />}
      </Helmet>
      <ErrorHandler><Fade in={true} >{children ?? <div />}</Fade></ErrorHandler>
    </Fragment>
  );
};

export default Page;
